
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ProjectTableEventSelector extends Vue {
    @Prop({ default: () => [] }) options!: Array<{ id: number; name: string }>;

    @Prop({ default: () => [] }) selectedEventIds!: Array<number>;

    values: Array<{ id: number; name: string }> = [];

    get safeOptions(): Array<{ id: number; name: string }> {
        return this.options || [];
    }

    @Watch('options', { immediate: true, deep: true })
    @Watch('selectedEventIds', { immediate: true, deep: true })
    setValues(): void {
        const selectedIds = this.selectedEventIds || [];
        this.values = this.safeOptions.filter((option) =>
            selectedIds.includes(option.id),
        );
    }

    @Emit('on-select')
    onSelect(option: { id: number; name: string }): number {
        return option.id;
    }

    @Emit('on-remove')
    onRemove(option: { id: number; name: string }): number {
        return option.id;
    }
}
